import { AlarmSubscriptionsForUser } from '@api-model/alarmSubscriptionsForUser';
import { httpClient } from '@infrastructure/http/HttpClient';
import { apiPaths } from '@infrastructure/http/apiPaths';
import { createAsyncThunk } from '@reduxjs/toolkit';

const getAlarmSubscriptions = createAsyncThunk('alarmSubscriptions/getAlarmSubscriptions', async () => {
  const response = await httpClient.get<AlarmSubscriptionsForUser>(apiPaths.alarmSubscription.alarmSubscriptions);

  return response.data;
});

const handleSubscribeAlarmsForAccount = createAsyncThunk(
  'alarmSubscriptions/handleSubscribeAlarmsForAccount',
  async ({ subscribe }: { subscribe: boolean }) => {
    const response = subscribe
      ? await httpClient.post(apiPaths.alarmSubscription.account)
      : await httpClient.delete(apiPaths.alarmSubscription.account);

    return { ...response.data, subscribe };
  }
);

const handleSubscribeAlarmsForSite = createAsyncThunk(
  'alarmSubscriptions/handleSubscribeAlarmsForSite',
  async ({ siteId, subscribe }: { siteId: number | string; subscribe: boolean }) => {
    const response = subscribe
      ? await httpClient.post(apiPaths.alarmSubscription.site({ siteId }))
      : await httpClient.delete(apiPaths.alarmSubscription.site({ siteId }));

    return { ...response.data, siteId, subscribe };
  }
);

export const thunks = {
  getByClaims: getAlarmSubscriptions,
  handleSubscribeAlarmsForAccount,
  handleSubscribeAlarmsForSite,
};
